import { render, staticRenderFns } from "./WalletSummary.vue?vue&type=template&id=b044991c&scoped=true"
import script from "./WalletSummary.vue?vue&type=script&lang=js"
export * from "./WalletSummary.vue?vue&type=script&lang=js"
import style0 from "./WalletSummary.vue?vue&type=style&index=0&id=b044991c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b044991c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
